import { api } from "shared/config/api/api";
import type { AuthResponse } from "entities/user";
import type { TelegramVerifyRequest } from "../model/types";

export const twoFactorVerifyApi = api.injectEndpoints({
  endpoints: (builder) => ({
    verifyTelegramCode: builder.mutation<AuthResponse, TelegramVerifyRequest>({
      query: (body) => ({
        url: "/auth/2fa/telegram/verify",
        method: "POST",
        body,
      }),
    }),
  }),
});

export const { useVerifyTelegramCodeMutation } = twoFactorVerifyApi;
